import apiClient from '@u/apiClient'
import gravePlot from '@/store/modules/gravePlot/index'
import ListGravePlotController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/ListGravePlotController'
import SearchGravePlotForPersonController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/SearchGravePlotForPersonController'
import SearchGravePlotForController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/SearchGravePlotForController'
import GetGravePlotController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/GetGravePlotController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import CreateGravePlotController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/CreateGravePlotController'
import UpdateGravePlotController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/UpdateGravePlotController'
import SetMainImageToGravePlot from '@/wayfinder/actions/App/Http/Controllers/GravePlot/SetMainImageToGravePlot'
import SetLocationToGravePlotFromImageController from '@/wayfinder/actions/App/Http/Controllers/GravePlot/SetLocationToGravePlotFromImageController'

const baseErrors = {}

export default {
  deleteGravePlot({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`/api/grave-plot/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteGravePlot: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/grave-plot/${payload.id}/undo-delete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region fetch

  fetchGravePlotList({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ListGravePlotController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchExistingGravePlotForPerson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SearchGravePlotForPersonController.get({ person: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchExistingGravePlot({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SearchGravePlotForController.get({ person: payload.person_id }),
          { params: payload }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchGravePlotById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetGravePlotController.get({ grave_plot: payload.grave_plot_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewGravePlot({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get(), {
          params: {
            ...payload.params,
            model: 'GravePlot'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeGravePlot({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateGravePlotController.post(), payload.grave_plot)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateGravePlot({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateGravePlotController.put({ grave_plot: payload.id }),
          payload.grave_plot
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  updateMainImage({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(SetMainImageToGravePlot.get({ grave_plot: payload.id }), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  setLocation({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SetLocationToGravePlotFromImageController.get({
            grave_plot: payload.id
          }),
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
